module.exports = "https://coursera_assets.s3.amazonaws.com/images/2140de03dbb6c217b8252daec8c2492a.png";